var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStockimg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 39,
    viewBox: "0 0 53 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0673 0L0 11.074L8.84918 16.183V13.6178L11.056 12.3435L8.838 11.063L19.0714 5.1196L43.9461 19.5243L33.7191 25.4283L16.5387 15.5089L14.3315 16.7824V19.348L29.2904 27.9841L19.0689 33.8859L0.725865 23.3262V28.4369L19.0698 39L52.7947 19.5291L19.0673 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5042 24.4373L19.0195 25.8733L13.5102 22.6946V16.308L19.0195 13.1293L26.4342 17.4088V12.9761L19.0195 8.69394L9.67035 14.0915V24.911L19.0195 30.3086L25.3453 26.655L21.5042 24.4373Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.7947,
    height: 39,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockimg);
export default __webpack_public_path__ + "static/media/stockimg.e3894e2003d24adf10bdbe388ea45fc6.svg";
export { ForwardRef as ReactComponent };